import React from 'react';
import { motion } from 'framer-motion';

const DeviceMockup = ({ desktopImage, mobileImage, projectTitle }) => {
  return (
    <div className="relative w-full flex items-end justify-center gap-1 md:gap-4 py-4 md:py-8">
      {/* MacBook Mockup */}
      <motion.div 
        className="relative"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* MacBook Container - bigger on mobile */}
        <div className="relative w-[260px] md:w-[380px] lg:w-[480px]">
          {/* Screen bezel */}
          <div className="relative bg-[#1d1d1f] rounded-t-lg md:rounded-t-2xl p-[4px] md:p-[6px]">
            {/* Camera */}
            <div className="absolute top-1 md:top-1.5 left-1/2 -translate-x-1/2 w-1.5 md:w-2 h-1.5 md:h-2 bg-[#3a3a3c] rounded-full z-20" />
            {/* Screen */}
            <div className="relative bg-black rounded-sm md:rounded-lg overflow-hidden">
              <img 
                src={desktopImage} 
                alt={`${projectTitle} - Desktop`}
                className="w-full h-auto object-cover object-top"
                style={{ aspectRatio: '16/9' }}
              />
            </div>
          </div>
          {/* Base */}
          <div className="relative h-2 md:h-4 bg-gradient-to-b from-[#8e8e93] to-[#636366] rounded-b-sm">
            {/* Notch */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 md:w-28 h-0.5 md:h-1 bg-[#48484a] rounded-b-full" />
          </div>
          {/* Bottom base */}
          <div className="relative h-0.5 md:h-1 bg-[#3a3a3c] mx-6 md:mx-10 rounded-b-lg" />
        </div>
      </motion.div>

      {/* iPhone Mockup - Blue color */}
      <motion.div 
        className="relative -ml-2 md:-ml-4"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        {/* iPhone Container - bigger on mobile */}
        <div 
          className="relative w-[75px] md:w-[100px] lg:w-[120px] rounded-[12px] md:rounded-[20px] lg:rounded-[24px] p-[3px] md:p-[4px]"
          style={{ 
            background: 'linear-gradient(145deg, #1c3a4f 0%, #0f2433 100%)',
            boxShadow: '0 8px 30px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.08)'
          }}
        >
          {/* Side buttons */}
          <div className="absolute -left-[1px] md:-left-[2px] top-[20%] w-[1px] md:w-[2px] h-4 md:h-5 bg-[#1c3a4f] rounded-l" />
          <div className="absolute -left-[1px] md:-left-[2px] top-[30%] w-[1px] md:w-[2px] h-5 md:h-8 bg-[#1c3a4f] rounded-l" />
          <div className="absolute -left-[1px] md:-left-[2px] top-[42%] w-[1px] md:w-[2px] h-5 md:h-8 bg-[#1c3a4f] rounded-l" />
          <div className="absolute -right-[1px] md:-right-[2px] top-[28%] w-[1px] md:w-[2px] h-6 md:h-10 bg-[#1c3a4f] rounded-r" />
          
          {/* Screen */}
          <div className="relative bg-black rounded-[9px] md:rounded-[16px] lg:rounded-[20px] overflow-hidden">
            <img 
              src={mobileImage} 
              alt={`${projectTitle} - Mobile`}
              className="w-full h-auto object-cover object-top"
              style={{ aspectRatio: '9/19.5' }}
            />
          </div>
          
          {/* Home indicator */}
          <div className="absolute bottom-0.5 md:bottom-1 left-1/2 -translate-x-1/2 w-8 md:w-10 h-[2px] md:h-[3px] bg-white/30 rounded-full" />
        </div>
      </motion.div>
    </div>
  );
};

export default DeviceMockup;
